import { createContext, useMemo } from "react";
import { useManageModal } from "src/hooks/useManageModal";
import UpdateOrdersModal from "./components/UpdateOrdersModal";

type ContextType = {
  updateActions: {
    handleOpen: () => void;
    handleClose: () => void;
  };
};

export const OrdersModalContext = createContext<ContextType>({
  updateActions: {
    handleOpen: () => {},
    handleClose: () => {},
  },
});

interface Props {
  children: React.ReactNode;
}

const OrdersModalProvider = ({ children }: Props) => {
  const [openUpdate, updateActions] = useManageModal();

  const value = useMemo(
    () => ({
      updateActions,
    }),
    [updateActions]
  );

  return (
    <OrdersModalContext.Provider value={value}>
      {children}
      <UpdateOrdersModal
        open={openUpdate}
        onClose={updateActions.handleClose}
      />
    </OrdersModalContext.Provider>
  );
};

export default OrdersModalProvider;
